module.exports = __webpack_public_path__ + "static/img/8.917b906.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/eng/8.png
// module id = ReBT
// module chunks = 0